import axios from "axios";

export const piperunnerCmsApiEndpoint = axios.create({
  baseURL: "https://cms-api.piperunner.in",
  headers: {
    "auth-key": "2756ac4a-08cb-465a-b4a8-3b197b0f41d7",
    "project-id": "CKTCYYOzA7p5h2QWxyW4",
  },
});
